import comp from "./StudentBlockScreen";
export default comp;
